//
//  index.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { BrowserRouter, Routes } from "react-router-dom";
import { createAllRoutes } from "./config";

/**
 * アプリケーション全体のルーティング設定
 */
export const AppRoutes = () => {
  const routes = createAllRoutes();
  return (
    <BrowserRouter>
      <Routes>{routes}</Routes>
    </BrowserRouter>
  );
};
